/**
 * Maps database and API errors to user-friendly messages
 * Prevents exposure of internal database details
 */
export function mapDatabaseError(error: any): string {
  const message = error?.message?.toLowerCase() || '';
  
  // Map specific database errors
  if (message.includes('player_name_format') || message.includes('name') && message.includes('constraint')) {
    return 'Name can only contain letters, numbers, and spaces';
  }
  
  if (message.includes('room_code_format') || message.includes('id') && message.includes('constraint')) {
    return 'Invalid room code format';
  }
  
  if (message.includes('duplicate key')) {
    return 'This room code already exists. Please try again.';
  }
  
  if (message.includes('foreign key') || message.includes('violates')) {
    return 'Room not found or no longer available';
  }
  
  if (message.includes('rls') || message.includes('policy')) {
    return 'You do not have permission to perform this action';
  }
  
  if (message.includes('auth') || message.includes('authentication')) {
    return 'Authentication error. Please try again.';
  }
  
  // Generic fallback - never expose raw database errors
  return 'Something went wrong. Please try again.';
}
